import React from 'react';
import { useTranslation } from 'react-i18next';

const AddressProgress: React.FC<{
  step: 1 | 2 | 3;
  hasProductSelection: boolean;
}> = ({ step, hasProductSelection }) => {
  const { t } = useTranslation();
  const steps = [
    t('modal.address.agreement.step_title', {
      defaultValue: 'Agree to terms'
    }),
    ...(hasProductSelection
      ? [
          t('modal.address.select_product_title', {
            defaultValue: 'Select your product'
          })
        ]
      : []),
    t('modal.address.agreement.address_step_title', {
      defaultValue: 'Enter address details'
    })
  ];

  return (
    <div className="relative mb-4 flex w-full items-start rounded-lg bg-[#FAFAF9] px-3 py-3">
      <div
        className={`absolute top-[22px] border-t border-dashed border-[#D6D3D1] ${
          hasProductSelection ? 'left-1/6 right-1/6' : 'left-1/4 right-1/4'
        }`}
      />
      {steps.map((label, index) => {
        const number = (index + 1) as 1 | 2 | 3;
        const completed = step > number;
        const active = step === number;
        return (
          <div
            key={label}
            className="relative z-[1] flex flex-1 flex-col items-center gap-2"
          >
            <div
              className={`h-5 w-5 rounded-full border text-center text-xs font-medium leading-[18px] ${
                completed
                  ? 'border-[#079455] bg-[#079455] text-white'
                  : active
                    ? 'border-[#D6D3D1] bg-white text-[#292524]'
                    : 'border-[#E7E5E4] bg-white text-[#A8A29E]'
              }`}
            >
              {completed ? '✓' : number}
            </div>
            <div
              className={`text-center text-sm font-medium leading-5 ${
                active || completed ? 'text-[#292524]' : 'text-[#78716C]'
              }`}
            >
              {label}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AddressProgress;
